import { useGetPath } from '@hooks/interview/useGetPath';
import { useCameraSession } from './useCameraSession';

export function useRoomCameraState() {
  const { getCameraState } = useCameraSession();
  const { rootPath } = useGetPath();

  const getRoutePath = () => {
    const cameraState = getCameraState();
    return cameraState === 'on'
      ? `${rootPath.ROOM}?camera=on`
      : `${rootPath.ROOM}?camera=off`;
  };

  return { getRoutePath };
}
